import { assoc, curry, keys, reduce } from 'ramda';

// Convert array into object keyed by IDs
export const objectify = arr => reduce((acc, value) =>
  assoc(value.id, value, acc),
  {},
  arr,
);

/**
 * Creates a new object with the own properties of the provided object, but the
 * keys renamed according to the keysMap object as `{oldKey: newKey}`.
 */
export const renameKeys = curry((keysMap, obj) =>
  reduce((acc, key) => assoc(keysMap[key] || key, obj[key], acc), {}, keys(obj))
);
